import axios from "axios"
const BASE_URL = process.env.REACT_APP_API_URL

class ProgramApi {
  addProgram(data, config) {
    return axios.post(BASE_URL + "/admin/program/create", data, config)
  }

  getProgram(config) {
    return axios.get(BASE_URL + "/admin/program/programDetails", config)
  }

  getProgramByInstitue(institutionCode, config) {
    return axios.get(
      `${BASE_URL}/admin/institution/programDetails/${institutionCode}`,
      config,
    )
  }

  getProgramById(prorgamId, config) {
    return axios.get(
      `${BASE_URL}/admin/program/programDatabyId/${prorgamId}`,
      config,
    )
  }

  updatePorgram(data, config) {
    return axios.put(BASE_URL + "/admin/program/updateProgram", data, config)
  }


  uploadProgramByExcel(data, config) {
    return axios.post(
      BASE_URL + "/admin/program/uploadProgram",
      data,
      config,
    )
  }



}

const programApi = new ProgramApi()
export default programApi
